"use strict";
var theme = {
  init: function () {
    theme.backgroundImage();
    theme.backgroundImageMobile();
    theme.swiperSlider();
    theme.stickyHeader();
    theme.instagramModal();
  },
  /**
   * Background Image
   * Adds a background image link via data attribute "data-image-src"
   */
  backgroundImage: () => {
    var bg = document.querySelectorAll(".bg-image");
    bg.forEach((el) => {
      var url = el.getAttribute("data-image-src");
      if (url) {
        el.style.backgroundImage = `url('${url}')`;
      }
    });
  },
  /**
   * Background Image Mobile
   * Adds .mobile class to background images on mobile devices for styling purposes
   */
  backgroundImageMobile: () => {
    var isMobile =
      /Android|webOS|iPhone|iPad|MacIntel.*Touch|iPod|BlackBerry/i.test(
        navigator.userAgent,
      );
    if (isMobile) {
      document.querySelectorAll(".image-wrapper").forEach((el) => {
        el.classList.add("mobile");
      });
    }
  },
  /**
   * Swipe Slider
   */
  swiperSlider: function () {
    var carousel = document.querySelectorAll(".swiper-container");
    for (var i = 0; i < carousel.length; i++) {
      var slider1 = carousel[i];
      slider1.classList.add("swiper-container-" + i);
      var controls = document.createElement("div");
      controls.className = "swiper-controls";
      var pagi = document.createElement("div");
      pagi.className = "swiper-pagination";
      var navi = document.createElement("div");
      navi.className = "swiper-navigation";
      var prev = document.createElement("div");
      prev.className = "swiper-button swiper-button-prev";
      var next = document.createElement("div");
      next.className = "swiper-button swiper-button-next";
      slider1.appendChild(controls);
      controls.appendChild(navi);
      navi.appendChild(prev);
      navi.appendChild(next);
      controls.appendChild(pagi);

      var sliderAllowTouchMove = slider1.getAttribute("data-drag") !== "false";
      var sliderAutoPlayTime = slider1.getAttribute("data-autoplaytime")
        ? slider1.getAttribute("data-autoplaytime")
        : 6000;
      var sliderAutoHeight = slider1.getAttribute("data-autoheight") === "true";
      var sliderCentered = slider1.getAttribute("data-centered") === "true";
      var sliderEffect = slider1.getAttribute("data-effect")
        ? slider1.getAttribute("data-effect")
        : "slide";
      var sliderMargin = slider1.getAttribute("data-margin")
        ? slider1.getAttribute("data-margin")
        : 32;
      var sliderLoop = slider1.getAttribute("data-loop") === "true";
      var sliderResizeUpdate =
        slider1.getAttribute("data-resizeupdate") !== "false";
      var sliderReverseDirection =
        slider1.getAttribute("data-reverse") === "true";
      var sliderSpeed = slider1.getAttribute("data-speed")
        ? slider1.getAttribute("data-speed")
        : 500;
      var sliderWatchOverflow =
        slider1.getAttribute("data-watchoverflow") !== "false";

      if (slider1.getAttribute("data-items-auto") === "true") {
        var slidesPerViewInit = "auto";
        var breakpointsInit = null;
      } else {
        var sliderItems = slider1.getAttribute("data-items")
          ? slider1.getAttribute("data-items")
          : 3; // items in all devices
        var sliderItemsXs = slider1.getAttribute("data-items-xs")
          ? slider1.getAttribute("data-items-xs")
          : 1; // start - 575
        var sliderItemsSm = slider1.getAttribute("data-items-sm")
          ? slider1.getAttribute("data-items-sm")
          : Number(sliderItemsXs); // 576 - 767
        var sliderItemsMd = slider1.getAttribute("data-items-md")
          ? slider1.getAttribute("data-items-md")
          : Number(sliderItemsSm); // 768 - 991
        var sliderItemsLg = slider1.getAttribute("data-items-lg")
          ? slider1.getAttribute("data-items-lg")
          : Number(sliderItemsMd); // 992 - 1199
        var sliderItemsXl = slider1.getAttribute("data-items-xl")
          ? slider1.getAttribute("data-items-xl")
          : Number(sliderItemsLg); // 1200 - end
        var sliderItemsXxl = slider1.getAttribute("data-items-xxl")
          ? slider1.getAttribute("data-items-xxl")
          : Number(sliderItemsXl); // 1500 - end
        var slidesPerViewInit = sliderItems;
        var breakpointsInit = {
          0: {
            slidesPerView: Number(sliderItemsXs),
          },
          576: {
            slidesPerView: Number(sliderItemsSm),
          },
          768: {
            slidesPerView: Number(sliderItemsMd),
          },
          992: {
            slidesPerView: Number(sliderItemsLg),
          },
          1200: {
            slidesPerView: Number(sliderItemsXl),
          },
          1400: {
            slidesPerView: Number(sliderItemsXxl),
          },
        };
      }

      var swiper = slider1.querySelector(".swiper:not(.swiper-thumbs)");
      var slider = new Swiper(swiper, {
        on: {
          beforeInit: function () {
            if (
              slider1.getAttribute("data-nav") !== "true" &&
              slider1.getAttribute("data-dots") !== "true"
            ) {
              controls.remove();
            }
            if (slider1.getAttribute("data-dots") !== "true") {
              pagi.remove();
            }
            if (slider1.getAttribute("data-nav") !== "true") {
              navi.remove();
            }
          },
          init: function () {
            if (slider1.getAttribute("data-autoplay") !== "true") {
              this.autoplay.stop();
            }
            this.update();
          },
        },
        autoplay: {
          delay: sliderAutoPlayTime,
          disableOnInteraction: false,
          reverseDirection: sliderReverseDirection,
          pauseOnMouseEnter: false,
        },
        allowTouchMove: sliderAllowTouchMove,
        speed: parseInt(sliderSpeed),
        slidesPerView: slidesPerViewInit,
        loop: sliderLoop,
        centeredSlides: sliderCentered,
        spaceBetween: Number(sliderMargin),
        effect: sliderEffect,
        autoHeight: sliderAutoHeight,
        watchOverflow: sliderWatchOverflow,
        grabCursor: true,
        resizeObserver: false,
        updateOnWindowResize: sliderResizeUpdate,
        breakpoints: breakpointsInit,
        pagination: {
          el: carousel[i].querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          prevEl: slider1.querySelector(".swiper-button-prev"),
          nextEl: slider1.querySelector(".swiper-button-next"),
        },
      });
    }
  },
  /**
   * Sticky Header
   */
  stickyHeader: () => {
    var navbar = document.querySelector(".navbar");
    if (navbar == null) return;
    var options = {
      offset: 350,
      offsetSide: "top",
      classes: {
        clone: "navbar-clone fixed",
        stick: "navbar-stick",
        unstick: "navbar-unstick",
      },
      onStick: function () {
        var navbarClonedClass = this.clonedElem.classList;
        if (
          navbarClonedClass.contains("transparent") &&
          navbarClonedClass.contains("navbar-dark")
        ) {
          this.clonedElem.className = this.clonedElem.className.replace(
            "navbar-dark",
            "navbar-light",
          );
        }
      },
    };
    var banner = new Headhesive(".navbar", options);
  },
  /**
   * Instagram Modal
   * Shows the clicked item's video (autoplaying) or image directly from
   * Instagram's media_url, and points the "Ver en Instagram" links at the
   * post's permalink. Everything is cleared again on close.
   */
  instagramModal: () => {
    var modalEl = document.getElementById("instagramModal");
    if (modalEl == null) return;
    var video = modalEl.querySelector(".instagram-media-video");
    var imageLink = modalEl.querySelector(".instagram-media-image-link");
    var image = modalEl.querySelector(".instagram-media-image");
    var footerLink = modalEl.querySelector(".instagram-media-link");

    var reset = function () {
      if (video) {
        video.pause();
        video.removeAttribute("src");
        video.load();
        video.classList.add("d-none");
      }
      if (image) {
        image.src = "";
      }
      if (imageLink) {
        imageLink.classList.add("d-none");
        imageLink.href = "";
      }
    };

    // Open via Swiper's own "click" event (not a generic document click
    // listener), since Swiper only fires it for a real tap and already
    // suppresses it when the user was swiping/dragging the carousel.
    var swiperEl = document.querySelector(".swiper-instagram");
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.on("click", function (swiper, event) {
        var card = event.target.closest(".card--instagram");
        if (card) {
          bootstrap.Modal.getOrCreateInstance(modalEl).show(card);
        }
      });
    }

    // Keyboard access (Enter/Space), since the card is a plain div[role=button].
    document.querySelectorAll(".card--instagram").forEach(function (card) {
      card.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          bootstrap.Modal.getOrCreateInstance(modalEl).show(card);
        }
      });
    });

    modalEl.addEventListener("show.bs.modal", function (event) {
      var trigger = event.relatedTarget;
      if (!trigger) return;
      var mediaUrl = trigger.getAttribute("data-media-url") || "";
      var permalink = trigger.getAttribute("data-permalink") || "";
      var isVideo = trigger.getAttribute("data-is-video") === "1";

      if (footerLink) {
        footerLink.href = permalink;
      }

      if (isVideo && video) {
        video.classList.remove("d-none");
        video.src = mediaUrl;
        video.play().catch(function () {});
      } else if (image && imageLink) {
        image.src = mediaUrl;
        imageLink.href = permalink;
        imageLink.classList.remove("d-none");
      }
    });

    modalEl.addEventListener("hidden.bs.modal", reset);
  },
};

theme.init();
